import { Space, SpaceProps } from 'antd';
import { clsx } from 'clsx';
import { forwardRef } from 'react';

import s from './AntSpace.module.less';

interface Props extends SpaceProps {
  fullWidth?: boolean;
}

export const AntSpace = forwardRef<HTMLDivElement, Props>((props) => {
  const { fullWidth, ...rest } = props;

  return <Space {...rest} className={clsx(rest.className, fullWidth && s.fullWidth)} />;
});

AntSpace.displayName = 'AntSpace';
